<template>
  <div>
    <LoadingSpinner v-if="loading" />
    <section class="billing-summary" v-if="!loading">
      <div class="transactions animated fadeIn fast">
        <div class="contenedor">
          <div class="p-2 d-flex justify-content-between align-items-center">
            <h5 class="font-weight-bold mb-0">
              {{ $t("lang.label.summary") }}
            </h5>
            <!-- <button
              class="btn btn-secondary btn-sm"
              @click="goDowngrade()"
              v-if="currentUser.role_id == 4 && currentUser.is_agency == 1"
            >
              {{ $t("lang.label.deleteaccount") }}
            </button> -->
          </div>

          <div>
            <div class="row">
              <!-- card oliverlist account -->
              <div
                class="col-md-6 col-sm-12 pr-4"
                v-if="!['1', '3'].includes(user.role_id) && user.is_agency == 0"
              >
                <div class="card mt-3">
                  <div class="px-4 pb-2 pt-4">
                    <div class="row">
                      <div class="col-12">
                        <h5 class="font-weight-bold">
                          {{ $t("lang.label.account") }} Oliverlist
                        </h5>
                      </div>
                    </div>
                    <div class="body p-4">
                      <div
                        class=""
                        v-if="
                          (user.role_id == 2 &&
                            user.subscription_status_id != 0 &&
                            user.is_agency == 0) ||
                          (user.role_id == 4 && user.user_status_id != 3)
                        "
                      >
                        <p class="small" v-if="user.is_agency == 0">
                          License(s) Oliver
                          {{ plans[user.plan_id].name }}
                          ({{ (user.plan_price * 1).toFixed(2) }}€/mois) :
                          {{ activeUsers }}
                          <span
                            class="badge small text-uppercase"
                            :class="
                              user.subscription_status_id == 1
                                ? 'badge-success'
                                : 'badge-danger'
                            "
                            >{{
                              user.subscription_status_id == 1
                                ? "active"
                                : "canceled"
                            }}</span
                          >
                        </p>
                        <div class="d-flex mt-2" v-if="budget">
                          <button
                            v-if="user.is_agency == 0 && user.plan_id < 3"
                            class="btn btn-primary themed-button btn-sm mt-3 mr-2"
                            @click="goUpgrade()"
                          >
                            Upgrade
                          </button>
                          <button
                            class="btn btn-primary themed-button btn-sm mt-3"
                            @click="goDowngrade()"
                          >
                            {{ $t("lang.label.deletemyaccount") }}
                          </button>

                          <Tooltip
                            class="btn btn-sm question"
                            :text="$t('lang.payment.infounsubscribe')"
                            :width="'auto'"
                          >
                            <i class="icon-question font-weight-light"></i>
                          </Tooltip>
                        </div>
                      </div>
                      <div
                        v-if="
                          user.role_id == 2 &&
                          user.subscription_status_id == 0 &&
                          user.is_agency == 0
                        "
                      >
                        <p class="small">License(s) Oliver Plan free</p>
                        <button
                          class="btn btn-primary themed-button btn-sm mt-3 mr-2"
                          @click="goUpgrade()"
                        >
                          Upgrade
                        </button>
                      </div>
                      <div
                        v-if="user.is_agency == 1 && user.user_status_id == 3"
                      >
                        <p class="small">Account deleted</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- card payment method -->
              <div
                class="col-md-6 col-sm-12 pr-4"
                v-if="this.user.subscription_status_id != 0"
              >
                <div class="card mt-3">
                  <div class="px-4 pb-2 pt-4">
                    <div class="row">
                      <div class="col-12">
                        <h5 class="font-weight-bold">
                          {{ $t("lang.label.howyoupay") }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="body p-4">
                    <div
                      class="table-responsive table-transactions summary-card"
                    >
                      <table class="table table-hover" v-if="paymentMethod">
                        <tbody>
                          <tr>
                            <td>{{ $t("lang.label.company") }}</td>
                            <td class="text-right font-weight-bold">
                              {{ paymentMethod.companyName }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("lang.label.paymentpreference") }}</td>
                            <td
                              class="text-right font-weight-bold"
                              v-if="
                                paymentMethod.descriptionPayment &&
                                paymentMethod.descriptionPayment.includes(' - ')
                              "
                            >
                              <img
                                width="30px"
                                :src="typeBrand(paymentMethod.brand)"
                              />
                              {{ paymentMethod.card_number }}
                            </td>
                            <td class="text-right font-weight-bold" v-else>
                              {{ paymentMethod.descriptionPayment }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("lang.label.country") }}</td>
                            <td class="text-right font-weight-bold">
                              {{ paymentMethod.companyCountry }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="d-flex justify-content-center" v-else>
                        <div class="d-flex align-items-center">
                          <div>
                            <h6 class="d-inline text-center">
                              {{ $t("lang.label.nopaymentmethods") }}
                            </h6>
                            <p class="" v-if="!validProfile">
                              {{
                                $t(
                                  "lang.label.toaddapaymentmethodyoumustfirstcompleteyourbillingprofile"
                                )
                              }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <button
                        class="ml-4 float-right btn btn-sm btn-primary themed-button"
                        type="button"
                        @click="goPayment()"
                        v-if="validProfile"
                      >
                        {{ $t("lang.button.managepaymentmethods") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- card subscription -->
              <div
                class="col-md-6 col-sm-12 pr-4"
                v-if="this.user.subscription_status_id != 0"
              >
                <div class="card mt-3">
                  <div class="px-4 pb-2 pt-4">
                    <div class="row">
                      <div class="col-12">
                        <h5 class="font-weight-bold">
                          {{ $t("lang.label.subscription") }}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class="body p-4 summary-card" v-if="subscriptionData">
                    <div
                      class="table-responsive table-transactions summary-card"
                    >
                      <table class="table table-hover">
                        <tbody>
                          <tr>
                            <td>{{ $t("lang.label.subscription") }}</td>
                            <td class="text-right font-weight-bold">
                              <span
                                >{{
                                  subscriptionData.plan_id == 5
                                    ? "ConnectPulse"
                                    : "CRM"
                                }}
                                - {{ subscriptionData.price }}/{{
                                  $t("lang.label.month")
                                }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("lang.payment.last_billing_date") }}</td>
                            <td class="text-right font-weight-bold">
                              {{ payment_date }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t("lang.payment.next_billing_date") }}</td>
                            <td class="text-right font-weight-bold">
                              {{ next_payment_date }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div>
                      <!-- <button
                        class="ml-4 float-right btn btn-sm btn-primary themed-button"
                        style="text-transform: uppercase"
                        type="button"
                        @click="goUnsubscribe()"
                      >
                        {{ $t("lang.button.unsubscribe") }}
                      </button> -->
                    </div>
                  </div>
                  <div class="d-flex justify-content-center" v-else>
                    <div class="d-flex align-items-center">
                      <div class="row">
                        <div class="col-sm-12">
                          <h4 class="d-inline text-center">
                            {{ $t("lang.payment.no_subscription") }}
                          </h4>
                        </div>
                        <div class="col-sm-12 mt-3 ml-5">
                          <router-link
                            to="/upgrade"
                            class="ml-4 mb-3 float-right btn btn-sm btn-primary themed-button"
                            style="text-transform: uppercase"
                          >
                            {{ $t("lang.payment.admin_subscription") }}
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 col-sm-12 pr-4" v-if="user.role_id == 1">
                <div class="card mt-3 p-4">
                  <h3>{{ $t("lang.appointments.appt_tittle") }}</h3>
                  <form @submit.prevent="onSubmit">
                    <vue-form-generator
                      ref="apptPriceForm"
                      :schema="schema"
                      :model="this.model"
                      :options="formOptions"
                    >
                    </vue-form-generator>
                    <div class="text-center">
                      <button
                        class="btn btn-primary"
                        type="submit"
                        @click="saveChanges()"
                      >
                        {{ $t("lang.button.save") }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--//contenedor-->
      </div>
    </section>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { billingsService, subscriptionsService } from "@/_services";
import { mapState, mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tutorial from "@/components/Tutorial.vue";
import Tooltip from "@/components/Common/Tooltip.vue";
import Form from "@/components/Common/Form.vue";
import Vue from "vue";
import moment from "moment";
import jQuery from "jquery";
import { adminService } from "../../_services/admin.service";
import { billingUtilsMixin } from "@/_mixins/";
let $ = jQuery;

export default {
  data() {
    return {
      budget: false,
      percentage: 0,
      lastPayment: {},
      listTransactions: [],
      paymentMethod: {},
      cantDowngrade: true,
      loading: false,
      activeUsers: false,
      model: {},
      schemaDesubscription: {
        fields: [
          {
            type: "switch",
            label: "",
            model: "conectpulse",
            featured: true,
            textOn: "Sub On",
            textOff: "Sub Off",
            valueOn: "1",
            valueOff: "0",
            styleClasses: "col-md-6",
          },
        ],
      },
      schema: {
        fields: [
          {
            type: "input",
            inputType: "number",
            min: 200,
            step: 0.01,
            label: this.$t("lang.appointments.appt_price_lower_51"),
            model: "price_lower_51",
            featured: true,
            required: true,
            styleClasses: "col-md-12",
            validator: this.validateDecimalTwoPlaces,
          },
          {
            type: "input",
            inputType: "number",
            min: 200,
            step: 0.01,
            label: this.$t("lang.appointments.appt_price_500"),
            model: "price_500",
            featured: true,
            required: true,
            styleClasses: "col-md-12",
            validator: this.validateDecimalTwoPlaces,
          },
          {
            type: "input",
            inputType: "number",
            min: 200,
            step: 0.01,
            label: this.$t("lang.appointments.appt_price_2000"),
            model: "price_2000",
            featured: true,
            required: true,
            styleClasses: "col-md-12",
            validator: this.validateDecimalTwoPlaces,
          },
          {
            type: "input",
            inputType: "number",
            min: 200,
            step: 0.01,
            label: this.$t("lang.appointments.appt_price_greater_2000"),
            model: "price_greater_2000",
            featured: true,
            required: true,
            styleClasses: "col-md-12",
            validator: this.validateDecimalTwoPlaces,
          },
        ],
      },
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
    };
  },
  props: {
    validProfile: Boolean,
  },
  components: {
    Header,
    LoadingSpinner,
    Tutorial,
    Tooltip,
    Form,
  },
  mixins: [billingUtilsMixin],
  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      plans: (state) => state.plans.all,
      activePlans: (state) => state.plans.allActives,
      currentUser: (state) => state.authentication.user,
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    hasDeclinedPayments() {
      return (
        this.$store.state.authentication.toastNotificationData
          .hasDeclinedPayments.length > 0
      );
    },
    hasPendingPayments() {
      return (
        this.$store.state.authentication.toastNotificationData
          .hasPendingPayments.length > 0
      );
    },
    start_date() {
      if (this.subscriptionData) {
        if (this.subscriptionData.start_date) {
          return moment(
            String(this.subscriptionData.start_date.substr(0, 10))
          ).format("DD/MM/YYYY");
        } else {
          return "-";
        }
      }
    },
    next_payment_date() {
      if (this.subscriptionData) {
        if (this.subscriptionData.next_payment_date) {
          return moment(
            String(this.subscriptionData.next_payment_date.substr(0, 10))
          ).format("DD/MM/YYYY");
        } else {
          return "-";
        }
      }
    },
    payment_date() {
      if (this.lastPayment.payment_date) {
        return moment(
          String(this.lastPayment.payment_date.substr(0, 10))
        ).format("DD/MM/YYYY");
      } else {
        return "-";
      }
    },
    price_month() {
      return Number(this.subscriptionData.price).toFixed(0);
    },
  },

  created() {
    if (this.user.role_id == 1) this.initApptPrices();
    this.getData();
    Vue.nextTick(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  },
  methods: {
    ...mapActions("plans", {
      getAllPlans: "getAll",
    }),

    initApptPrices() {
      this.loading = true;
      adminService.getAppointmentPrices().then((res) => {
        if (
          res.status === 200 &&
          res.result.appt_prices != undefined &&
          res.result.appt_prices.price_500 != undefined
        ) {
          this.model = res.result.appt_prices;
          this.loading = false;
        } else {
          this.$swal({
            type: "error",
            title: this.$t("lang.general.error"),
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    },

    saveChanges() {
      this.$refs.apptPriceForm.validate();
      if (this.$refs.apptPriceForm.errors == undefined) {
        this.$refs.apptPriceForm.errors = [];
      }
      if (this.$refs.apptPriceForm.errors.length > 0) {
        return false;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.saveallchanges"),
        text: this.$t("lang.refuse.sure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.label.save"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          adminService.setAppointmentPrices(this.model).then((res) => {
            if (res.status == 200) {
              this.$swal({
                type: "success",
                title: this.$t("lang.label.great"),
                showConfirmButton: false,
                timer: 1500,
              });
            } else {
              this.$swal({
                type: "error",
                title: this.$t("lang.general.error"),
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },

    validateDecimalTwoPlaces(value) {
      if (value === undefined || value === null || value === "") {
        return [this.$t("lang.label.isrequired")];
      }

      const regex = /^\d+(\.\d{1,2})?$/;

      if (!regex.test(value)) {
        return [this.$t("lang.validation.number_decimal_negative")];
      }

      if (value < 200) {
        return [this.$t("lang.validation.number_more_than", { max: 200 })];
      }

      if (
        this.model.price_lower_51 > this.model.price_500 ||
        this.model.price_500 > this.model.price_2000 ||
        this.model.price_2000 > this.model.price_greater_2000
      ) {
        return [this.$t("lang.validation.number_ascending")];
      }
      return true; // Si es válido, devuelve `true`
    },

    getAllPlansActives() {
      this.getAllPlans({});
    },
    openModalDesubscription() {
      this.$modal.show("clientDesubscription");
    },
    closeModalDesubscription() {
      this.$modal.hide("clientDesubscription");
    },
    getData() {
      this.getSummary();
      this.getCurrency();
      this.getAllPlansActives();
    },
    typeBrand(payment) {
      switch (payment) {
        case "Visa": {
          return require("@/assets/images/visa-logo.png");
        }
        case "CB": {
          return require("@/assets/images/cb-logo.png");
        }
        case "Mastercard": {
          return require("@/assets/images/mc-logo.png");
        }
      }
    },
    getSummary() {
      this.loading = true;
      billingsService
        .getSummary()
        .then((result) => {
          this.budget = result.budget;
          this.percentage = result.percentage;
          this.lastPayment = result.lastPayment;
          this.listTransactions = result.transactionsByMonth;
          this.paymentMethod = result.defaultPaymentMethod;
          if (
            this.paymentMethod.descriptionPayment &&
            this.paymentMethod.descriptionPayment.includes(" - ")
          ) {
            const [brand, card_number] =
              this.paymentMethod.descriptionPayment.split(" - ");
            this.paymentMethod.brand = brand;
            this.paymentMethod.card_number = card_number;
          }
          this.activeUsers = result.activeUsers;
          if (result.subscriptionData) {
            this.subscriptionData = result.subscriptionData;
            this.modelSubscription = {
              conectpulse: this.subscriptionData.subscription_active,
            };
          }
        })
        .then((result) => {
          this.hasPaymentsPending();
          this.loading = false;
        });
    },
    getCurrency() {
      this.currency = "€";
    },
    goTransactions() {
      this.$emit("changeBillingTab", "TRANSACTIONS");
    },
    goPayment() {
      this.$emit("changeBillingTab", "PAYMENT");
    },
    hasPaymentsPending() {
      billingsService.getPendingPayments().then((response) => {
        if (!response && this.budget <= 0) {
          this.cantDowngrade = false;
        }
      });
    },
    goUpgrade() {
      this.$router.push("/upgrade");
    },
    deleteAccount() {
      clientsService.deleteAgency().then(
        (response) => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: true,
            timer: 1500,
          });
          this.$router.push("/login");
        },
        (error) => {
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.general." + error),
            showConfirmButton: true,
          });
        }
      );
    },
    goUnsubscribe() {
      this.$swal({
        type: "warning",
        title: this.$t("lang.payment.areyousureunsubscribe"),
        text: this.$t("lang.payment.infounsubscribe"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          console.log("Unsubscribe confirmed");
          const { dispatch } = this.$store;
          dispatch("authentication/getToastNotificationData").then(
            (response) => {
              if (this.hasPendingPayments) {
                this.$swal({
                  type: "warning",
                  title: this.$t("lang.payment.chargeattempt"),
                  html: this.$t("lang.payment.chargeattemptinfo2"),
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("lang.button.yes"),
                  cancelButtonColor: "#d33a2c",
                  cancelButtonText: this.$t("lang.button.cancel"),
                }).then((result) => {
                  if (result.value) {
                    this.loading = true;
                    billingsService.chargePendingPayments(0).then(
                      (response) => {
                        const { dispatch } = this.$store;
                        dispatch(
                          "authentication/getToastNotificationData"
                        ).then(() => {
                          this.loading = false;
                          this.showChargePendingResultSwal(response, {
                            successInfoKey:
                              "lang.payment.successfulinfopreunsubscribe",
                          }).then((swalResult) => {
                            if (swalResult.outcome === "success") {
                              this.unsubscribe();
                            } else if (swalResult.outcome !== "processing") {
                              this.$emit("changeBillingTab", "PAYMENT");
                            }
                          });
                        });
                      },
                      (error) => {
                        this.loading = false;
                        const { dispatch } = this.$store;
                        dispatch(
                          "authentication/getToastNotificationData"
                        ).finally(() => {
                          this.showChargePendingResultSwal(error, {
                            successInfoKey:
                              "lang.payment.successfulinfopreunsubscribe",
                          }).then((swalResult) => {
                            if (swalResult.outcome === "success") {
                              this.unsubscribe();
                            } else if (swalResult.outcome !== "processing") {
                              this.$emit("changeBillingTab", "PAYMENT");
                            }
                          });
                        });
                      }
                    );
                  }
                });
              } else {
                this.unsubscribe();
              }
            }
          );
        }
      });
    },
    unsubscribe() {
      subscriptionsService.cancel().then(
        (response) => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            showConfirmButton: false,
            timer: 1500,
          });
        },
        (error) => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.general." + error),
            showConfirmButton: true,
          });
        }
      );
    },
    goDowngrade() {
      if (!(this.currentUser.role_id == 4 && this.currentUser.is_agency == 1)) {
        this.$swal({
          type: "warning",
          text: this.$t("lang.general.permissiondenied"),
          showConfirmButton: true,
        });
        return;
      }
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousureyouwanttodeleteyouraccount"),
        text: this.$t("lang.label.deletewarningaccount"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        if (result.value) {
          const { dispatch } = this.$store;
          dispatch("authentication/getToastNotificationData").then(
            (response) => {
              if (this.budget > 0 || this.hasPendingPayments) {
                this.$swal({
                  type: "warning",
                  title: this.$t("lang.payment.chargeattempt"),
                  html: this.$t("lang.payment.chargeattemptinfo2"),
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  confirmButtonText: this.$t("lang.button.yes"),
                  cancelButtonColor: "#d33a2c",
                  cancelButtonText: this.$t("lang.button.cancel"),
                }).then((result) => {
                  if (result.value) {
                    this.loading = true;
                    billingsService.chargePendingPayments(1).then(
                      (response) => {
                        const { dispatch } = this.$store;
                        dispatch(
                          "authentication/getToastNotificationData"
                        ).then(() => {
                          this.loading = false;
                          this.showChargePendingResultSwal(response, {
                            successInfoKey:
                              "lang.payment.successfulinfopreunsubscribe",
                          }).then((swalResult) => {
                            if (swalResult.outcome === "success") {
                              this.deleteAccount();
                            } else if (swalResult.outcome !== "processing") {
                              this.$emit("changeBillingTab", "PAYMENT");
                            }
                          });
                        });
                      },
                      (error) => {
                        this.loading = false;
                        const { dispatch } = this.$store;
                        dispatch(
                          "authentication/getToastNotificationData"
                        ).finally(() => {
                          this.showChargePendingResultSwal(error, {
                            successInfoKey:
                              "lang.payment.successfulinfopreunsubscribe",
                          }).then((swalResult) => {
                            if (swalResult.outcome === "success") {
                              this.deleteAccount();
                            } else if (swalResult.outcome !== "processing") {
                              this.$emit("changeBillingTab", "PAYMENT");
                            }
                          });
                        });
                      }
                    );
                  }
                });
              } else {
                this.deleteAccount();
              }
            }
          );
        }
      });
    },
  },
};
</script>
<style>
.summary-card {
  min-height: 70px !important;
}

.btn.question {
  padding: 1px;
  padding-bottom: 10px;
  margin-left: 5px;
  width: 20px;
  border-radius: 50%;
  font-size: 0.8rem !important;
  height: 20px;
  border: 0.5px solid #9e9e9e;
  color: grey;
}
</style>
